import i18n from "../i18n";

// One date format across the app: "Oct 21, 2026" (short: "Oct 21").
// Spanish: "21 oct 2026" / "21 oct".
//
// A plain calendar day ("2026-10-21", a tour sheet's dateKey) is shown as
// that day — never shifted by the viewer's time zone. A full timestamp is
// shown in the viewer's own zone (formatDateUTC: a date stored as UTC
// midnight, shown as that calendar day).

const DAY_RE = /^\d{4}-\d{2}-\d{2}$/;
const localeOf = (lang) => (String(lang || i18n.language || "en").startsWith("es") ? "es-US" : "en-US");

function toDate(value) {
  if (value === null || value === undefined || value === "") return null;
  if (typeof value === "string" && DAY_RE.test(value)) return { d: new Date(`${value}T12:00:00Z`), utc: true };
  const d = value instanceof Date ? value : new Date(value);
  return Number.isNaN(d.getTime()) ? null : { d, utc: false };
}

function fmt(value, lang, opts, forceUtc = false) {
  const x = toDate(value);
  if (!x) return "";
  return new Intl.DateTimeFormat(localeOf(lang), { ...opts, ...(x.utc || forceUtc ? { timeZone: "UTC" } : {}) }).format(x.d).replace(/\.(?=\s|$|,)/g, "");
}

const LONG = { month: "short", day: "numeric", year: "numeric" };
const SHORT = { month: "short", day: "numeric" };

/** "Oct 21, 2026" (es: "21 oct 2026"). */
export const formatDate = (value, lang) => fmt(value, lang, LONG);

/** "Oct 21" (es: "21 oct"). */
export const formatShortDate = (value, lang) => fmt(value, lang, SHORT);

/** A date kept as UTC midnight (approval dates, lease terms): that calendar day. */
export const formatDateUTC = (value, lang) => fmt(value, lang, LONG, true);

/** "Oct 21, 2026, 3:45 PM" — a date with the time of day. */
export const formatDateTime = (value, lang) => fmt(value, lang, { ...LONG, hour: "numeric", minute: "2-digit" });

/** "2025-10" → "Oct 2025" (es: "oct 2025"). */
export const formatMonth = (ym, lang) => {
  if (!/^\d{4}-\d{2}$/.test(String(ym || ""))) return String(ym || "");
  return fmt(`${ym}-15`, lang, { month: "short", year: "numeric" });
};

/** "Sep 24 – Oct 23, 2026"; across years "Dec 20, 2025 – Jan 18, 2026". */
export const formatDateRange = (from, to, lang) => {
  if (!from || !to) return formatDate(from || to, lang);
  if (String(from).slice(0, 4) === String(to).slice(0, 4)) return `${formatShortDate(from, lang)} – ${formatDate(to, lang)}`;
  return `${formatDate(from, lang)} – ${formatDate(to, lang)}`;
};
